import { render } from "./OrderReturnInfosModal.vue?vue&type=template&id=547bc078&scoped=true&ts=true&lang=pug"
import script from "./OrderReturnInfosModal.vue?vue&type=script&lang=ts"
export * from "./OrderReturnInfosModal.vue?vue&type=script&lang=ts"

import "./OrderReturnInfosModal.vue?vue&type=style&index=0&id=547bc078&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547bc078"]])

export default __exports__